import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconRtfSizeM from './FileIconRtf_size_m';
import FileIconRtfSizeS from './FileIconRtf_size_s';

export const FileIconRtf = createFileIcon({
  m: FileIconRtfSizeM,
  s: FileIconRtfSizeS,
  name: 'FileIconRtf',
});
